import React from "react";
import { StyledBackDrop } from "../styles";

const BackDrop = () => {
  return <StyledBackDrop>I'll be hidden</StyledBackDrop>;
};

export default BackDrop;
